import { PublicOrgRouteShell } from '@/components/public/PublicOrgRouteShell';
import PublicLessonsPage from './PublicLessonsPage';

/**
 * `/club-academy/:slug/lessons` — public lesson catalog in the org white-label shell.
 */
export default function OrgLessonsRoute() {
  return (
    <PublicOrgRouteShell>
      <PublicLessonsPage suppressPublicChrome />
    </PublicOrgRouteShell>
  );
}
